import { AdminService } from './../../_services/admin.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-free-worksheet',
  templateUrl: './admin-free-worksheet.component.html',
  styleUrls: ['./admin-free-worksheet.component.css']
})
export class AdminFreeWorksheetComponent implements OnInit {

  constructor(private adminService:AdminService) { }
  worksheets =[]
  loading = false
  isEmpty=false
  downloading=false
  idRequest=0
  imageSource=""
  ngOnInit(): void {
    this.getFreeWorksheetRequests()

  }

  getFreeWorksheetRequests(){
    this.loading=true
    this.isEmpty=true
    this.adminService.getFreeWorksheetRequests().subscribe(
      ws=>{
        this.worksheets=ws
        if(ws.length!=0){
          this.isEmpty=false
        }
        this.loading=false
      }
    )
  }
  viewFreeWorkBook(worksheet_code:string,id:number){

  for(let x of this.worksheets){
    if(x['id']==id){
      this.idRequest=id
      break
    }
  }

    this.downloading=true
    this.adminService.viewFreeWorksheet(worksheet_code).subscribe(
      x=>{
        this.imageSource= `data:application/pdf;base64,${x}`;
        this.downloadMyPdf()

      }
    )
  }



  downloadMyPdf() {
     const link = document.createElement("a");
     let fileName= "boldungu_free_quiz_"+Date.now()
     link.href = this.imageSource;
     link.download = `${fileName}.pdf`
     this.downloading=false
     link.click();
   }

}
